/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2015, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../app/nls/StringResources'
], function(
	StringResources
) {

	const AUTHOR_DASHBOARD_CAPABILITY = 'canAuthorDashboard';
	class ActionHandler {

		/**
		 * Menu item handler
		 */
		onSelectItem(context) {
			this._openCreateView(context);
		}

		/**
		 * Determine when we show/hide the menu item
		 */
		isItemVisible(options) {
			if (this._isSelectionValid(options, true)) {
				// check if user has dashboard authoring capability on these sources
				const selections = options.target && options.target.activeObject && options.target.activeObject.aSelectedContext;
				return this._hasCapability(selections);
			}
			return false;
		}

		/**
		 * Default action handler
		 */
		doAction(context) {
			if (this._validateSelectionCapabilities(context)) {
				return this._openCreateView(context);
			}
		}

		/**
		 * Determine if we can execute the action based on the selection type and permissions.
		 * For performance reason, we delay the capability check of these sources until user selects it (when doAction is called)
		 */
		canExecute(options) {
			return this._isSelectionValid(options, true);
		}

		_validateSelectionCapabilities(context) {
			const selections = context.target && context.target.activeObject && context.target.activeObject.aSelectedContext;
			if (this._hasCapability(selections)) {
				return true;
			} else {
				context.glassContext.appController.showToast(StringResources.get('noCapabilityForCreateDashboard'), {
					type: 'error',
					preventDuplicates: true
				});
				return false;
			}
		}

		_openCreateView(context) {
			var perspectiveOptions = {
				content: {}
			};
			var sources = this._getSources(context);
			if (sources && sources.length > 0) {
				perspectiveOptions.content.sources = sources;
			}
			return context.glassContext.appController.openAppView('createBoard', perspectiveOptions);
		}

		_getSources(options) {
			var isSelectionValid = this._isSelectionValid(options, false);
			var dataSourcesArray = null;
			if (isSelectionValid) {
				dataSourcesArray = [];
				var selections = options.target.activeObject.aSelectedContext;
				for (var i = 0; i < selections.length; i++) {
					dataSourcesArray.push({
						assetId: selections[i].id,
						type: selections[i].type,
						name: selections[i].defaultName,
						searchPath: selections[i].searchPath,
						isOlapPackage: selections[i].userInterfaces && selections[i].userInterfaces.length && selections[i].userInterfaces.includes('analysisStudio')
					});
				}
			}

			return dataSourcesArray;
		}

		_isSelectionValid(options, defaultValue) {
			const typesToOpen =  ['module', 'dataSet2', 'uploadedFile', 'package'];
			var selection = options.target && options.target.activeObject && options.target.activeObject.aSelectedContext;
			if (selection) {
				for (var i = 0; i < selection.length; i++) {
					const selectedSource = selection[i];
					if (!typesToOpen.includes(selectedSource.type)) {
						return false;
					}

					const requiredPermission = 'read';
					if (!(selectedSource.permissions && selectedSource.permissions.length && selectedSource.permissions.includes(requiredPermission))) {
						return false;
					}

					if (selectedSource.disabled && selectedSource.disabled.toString().toLowerCase() === 'true') {
						return false;
					}
				}
				return true;
			}
			return defaultValue || false;
		}

		_hasCapability(selections) {
			if (selections) {
				for (var i = 0; i < selections.length; i++) {
					const selectedSource = selections[i];
					if (!(selectedSource.effectiveUserCapabilities && selectedSource.effectiveUserCapabilities.length && selectedSource.effectiveUserCapabilities.includes(AUTHOR_DASHBOARD_CAPABILITY))){
						return false;
					}
				}
			}
			return true;
		}
	}

	return ActionHandler;
});
